import { Capacitor } from '@capacitor/core';

type AndroidPullToRefreshBridge = {
  setEnabled: (enabled: string) => void;
};

const getBridge = (): AndroidPullToRefreshBridge | undefined => {
  if (!Capacitor.isNativePlatform()) {
    return undefined;
  }

  return (window as Window & { AndroidPullToRefresh?: AndroidPullToRefreshBridge }).AndroidPullToRefresh;
};

export const setNativePullToRefreshEnabled = (enabled: boolean) => {
  getBridge()?.setEnabled(enabled ? 'true' : 'false');
};
